import { useEffect, useState } from "react";
import { searchApts } from "../api/apts";

const PAGE_SIZE = 20;

export const useAptSearch = (searchString) => {
  const [apts, setApts] = useState(null);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPage = (pageNum) => {
    setIsLoading(true);
    const offset = (pageNum - 1) * PAGE_SIZE;

    searchApts({ searchString, offset })
      .then((res) => {
        const results = res.data?.apts || res.data?.results || [];
        setApts(results);

        searchApts({ searchString, offset: offset + PAGE_SIZE })
          .then((nextRes) => {
            const nextResults =
              nextRes.data?.apts || nextRes.data?.results || [];
            setHasNext(nextResults.length > 0);
          })
          .catch(() => setHasNext(false));
      })
      .catch((e) => {
        console.error("[useAptSearch] error:", e);
        setApts([]);
        setHasNext(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setPage(1);
    fetchPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString]);

  const goToPage = (pageNum) => {
    if (pageNum < 1 || isLoading) return;
    setPage(pageNum);
    fetchPage(pageNum);
  };

  const nextPage = () => {
    if (hasNext) goToPage(page + 1);
    console.log("hi");
  };

  const prevPage = () => {
    if (page > 1) goToPage(page - 1);
  };

  return { apts, page, hasNext, isLoading, nextPage, prevPage };
};
